/**
 * Aetherfall audio: procedural SFX, generative music and ambience on Web Audio.
 *
 * Usage (browser):
 *   import { audio, bindSimAudio } from './audio';
 *   audio.attachUnlock();                 // context starts on the first gesture
 *   audio.setTheme('meadow');             // remembered until unlocked
 *   const sfx = bindSimAudio(audio, ctx); // ctx: positions + local/monster/boss lookups
 *   // per frame: sfx.handle(events); sfx.frame(dt);
 *   audio.play('coin');
 *
 * In Node/tests every call is a silent no-op.
 */
import { AudioEngine } from './AudioEngine';

export {
  AudioEngine,
  BUS_IDS,
  DEFAULT_SPATIAL,
  spatialize,
  webAudioSupported,
  type AudioEngineOptions,
  type AudioSettings,
  type BusId,
  type Listener,
  type PlayOptions,
  type SpatialParams,
  type SpatialResult,
  type VolumeTarget,
} from './AudioEngine';
export { SFX, SFX_IDS, isSfxId, sfxDef, type SfxDef, type SfxId } from './sfx';
export {
  MusicEngine,
  THEMES,
  THEME_IDS,
  LEITMOTIF,
  ThemeSequencer,
  themeForZone,
  validateTheme,
  type AmbienceId,
  type BarPlan,
  type InstrumentId,
  type MusicHost,
  type NoteEvent,
  type ThemeDef,
  type ThemeId,
} from './music';
export {
  bindSimAudio,
  CAST_SFX,
  createSimAudioState,
  handleSimEvent,
  lootSfx,
  mapSimEvent,
  materialFor,
  sfxForVfx,
  shapeSize,
  uiSound,
  UI_SFX,
  type SfxCue,
  type SfxPlayer,
  type SimAudioBinding,
  type SimAudioContext,
  type SimAudioState,
  type Surface,
  type UiSound,
} from './bindings';
export { VoicePool, type VoiceGrant, type VoiceRequest } from './voicePool';

/** Shared engine for the whole game (lazy: no AudioContext until `unlock()`). */
export const audio = new AudioEngine();
